<template>
  <div class="container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'reseller-company-list'})" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          ></path>
        </svg>
        <p>Back to Companies</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.push({name: 'reseller-company-list'})" class="secondary-button">
            <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
            <primary-button >Add Manual Payment</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title">Add Manual Payment</span>
      <div class="col-wrapper">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
  },
  data: () => ({
    contactError: null,
  }),
  created() {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.help {
  margin: 15px 0 15px 0;
}
.row .help:last-child {
  margin-left: 15px;
}
.container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 185px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    min-height: 395px;
    background-color: #ffffff;
    padding-top: 15px;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 18px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .col-wrapper {
      width: 100%;
      margin-left: 15px;
      margin-top: 20px;
      .col {
        float: left;
        .row {
          width: 100%;
          flex-wrap: nowrap;
          .input {
            padding-right: 15px;
          }
          .last {
            padding-right: 0;
          }
          .multiselect {
            width: 100%;
            // margin-right: 15px;
          }
          .row-first {
            width: 33.333%;
          }
          .row-second {
            width: 33.333%;
          }
          .row-address {
            width: 70%;
          }
          .row-zipcode {
            width: 30%;
          }
          .row-country {
            width: 50%;
          }
          .row-third {
            width: 25%;
          }
        }
        .input {
          margin-bottom: 15px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 900;
          }
        }
      }
      .upload-col {
        width: 30%;
        padding-right: 15px;
        padding-left: 0;
        float: left;
        .help {
          margin-top: 0;
        }
      }
      .fields-col {
        width: 70%;
        padding-right: 0;
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>

